import { render, staticRenderFns } from "./financeiro-tabela-indicacao.vue?vue&type=template&id=31fb8867"
import script from "./financeiro-tabela-indicacao.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-indicacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports